export const ExclusivityTypes = {
  Exclusive: 1,
  NonExclusive: 2,
  Holdback: 3,
};
